import React,{useState} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import './styles/App.css';
import TopTitle from './TopTitle';
import imgFrameBang1 from './img/main_img_1.jpg';
import imgFrameBang2 from './img/main_img_2.jpg';
import imgFrameBang3 from './img/main_img_3.jpg';
import imgFrameBang4 from './img/main_banner/main_img_4.jpg';
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption
  } from 'reactstrap';

  const items = [
        {
            src: `${imgFrameBang3}`,
            altText: 'Slide 1',
            caption: 'Slide 1',
            content: '',
        },
        {
            src: `${imgFrameBang2}`,
            altText: 'Slide 2',
            caption: 'Slide 2'
        },
        {
            src: `${imgFrameBang1}`,
            altText: 'Slide 3',
            caption: 'Slide 3'
        },
    
  ];

  const MainS = (props) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
  
    const next = () => {
      if (animating) return;
      const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
      setActiveIndex(nextIndex);
    }
  
    const previous = () => {
      if (animating) return;
      const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
      setActiveIndex(nextIndex);
    }
  
    const goToIndex = (newIndex) => {
      if (animating) return;
      setActiveIndex(newIndex);
    }

    console.log('activeIndex : ', activeIndex)

    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={item.src}
        >
          <img src={item.src} alt={item.altText} />
          <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
          <div className="mainTextWrap_mobile d-none">
              <div className="blueTitle_mobile mb-0">Always By Your Side</div>
              <div className="main_line_mobile" ></div>
              {
                  activeIndex === 3 ||  activeIndex === 0
                  ?
                  <>
                    <p className="titleInnerW_mobile mb-0">현대캐피탈</p>
                    <p className="titleInnerW_mobile mb-4 mb-md-2">신차할부 신차패키지 서비스</p>
                  </>
                  :
                  <>
                    <p className="titleInner_mobile mb-0">현대캐피탈</p>
                    <p className="titleInner_mobile mb-md-2">신차할부 신차패키지 서비스</p>
                  </>
              }
              
              
          </div>
        </CarouselItem>
      );
    });
  
    

    return (
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
    );
  }
  
  

function MainSlide_m() {

    

  return (
    
    <div className="position-relactive">
        <div>

            <MainS />
        </div>
    </div>

  );
}

export default MainSlide_m;